import { render, staticRenderFns } from "./Module.vue?vue&type=template&id=63a5612e&scoped=true"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"
import style0 from "./Module.vue?vue&type=style&index=0&id=63a5612e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5612e",
  null
  
)

export default component.exports